import { Confidence, type Context } from '@spotify-confidence/sdk';
import { createConfidenceWebProvider } from '@spotify-confidence/openfeature-web-provider';
import type { Telemetry } from '../types';
import { getInstrumentedFetch } from './instrumented-fetch';

const ENABLE_LOGGING = false;

interface ConfidenceProviderArgs {
  evaluationContext: Context;
  clientSecret: string;
  timeout: number;
  telemetry: Telemetry;
}

export function createConfidenceProvider({
  clientSecret,
  evaluationContext,
  timeout,
  telemetry,
}: ConfidenceProviderArgs) {
  return createConfidenceWebProvider(
    Confidence.create({
      context: evaluationContext as unknown as Context,
      clientSecret,
      timeout,
      logger: ENABLE_LOGGING ? console : {},
      environment: 'client',
      fetchImplementation: getInstrumentedFetch({ telemetry }),
    }),
  );
}
